import script from "./VideoEmbed.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoEmbed.vue?vue&type=script&setup=true&lang=js"

import "./VideoEmbed.vue?vue&type=style&index=0&id=162ae412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-162ae412"]])

export default __exports__